import { loadAppSettings } from './appSettings';

// Load runtime settings BEFORE importing appBootstrap.js — that module (and its static
// imports, e.g. the router's route definitions) reads ENV.* at import-eval time, so the
// settings fetch must resolve first. A dynamic import defers evaluation until then.
async function boot() {
  await loadAppSettings();
  await import('./appBootstrap');
}

boot().catch((error) => console.error('[strategic_express_web] boot failed', error));
